import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import AppConfig from '../appConfig';

const STATUS_IDS = [
    'mapLoading.statuses.project',
    'mapLoading.statuses.layers',
    'mapLoading.statuses.settings',
    'mapLoading.statuses.facilities',
];
const MESSAGE_INTERVAL = 4500;
const markSrc = () => `${AppConfig.constants.assetsBaseURL}/icons/logo.svg`;

export const MapLoadingIcon = () => (
    <span className="map-loading__medallion map-loading__medallion--small" aria-hidden="true">
        <span className="map-loading__orbit map-loading__orbit--thin" />
        <span className="map-loading__mark map-loading__mark--small">
            <img src={markSrc()} alt="" />
        </span>
    </span>
);

class MapLoading extends React.Component {
    constructor(props) {
        super(props);
        this.state = { index: 0 };
    }

    componentDidMount() {
        this.timer = setInterval(
            () => this.setState(({ index }) => ({ index: (index + 1) % STATUS_IDS.length })),
            MESSAGE_INTERVAL,
        );
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        const { intl } = this.props;
        const { index } = this.state;

        return (
            <div className="map-loading" data-testid="map-loading">
                <div className="map-loading__medallion" aria-hidden="true">
                    <span className="map-loading__glow" />
                    <span className="map-loading__ping" />
                    <span className="map-loading__orbit" />
                    <span className="map-loading__mark">
                        <img src={markSrc()} alt="" />
                    </span>
                </div>
                <span className="map-loading__title">
                    {intl.formatMessage({ id: 'mapLoading.title' })}
                </span>
                <span key={index} className="map-loading__message" role="status" aria-live="polite">
                    {intl.formatMessage({ id: STATUS_IDS[index] })}
                </span>
            </div>
        );
    }
}

MapLoading.propTypes = {
    intl: PropTypes.object.isRequired,
};

export default injectIntl(MapLoading);
